module.exports = __webpack_public_path__ + "static/media/Group 58 (1).26e270ab.png";